import { gql } from "@apollo/client";

export const CREATE_MEDICINE = gql`
    mutation createMedicine($data: CreateMedicineInput!) {
        createMedicine(data: $data) {
            id
            name
            need
            stock
            box
            due_date
            is_actived
            is_deleted
        }
    }
`;

export const UPDATE_MEDICINE = gql`
    mutation updateMedicine($data: UpdateMedicineInput!) {
        updateMedicine(data: $data) {
            id
            name
            need
            stock
            box
            due_date
            is_actived
            is_deleted
        }
    }
`;

export default CREATE_MEDICINE;
